// Recovered compiled webpack factory 23989. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { z: () => a });
  var n = r(38599);
  let a = (e = !0) => {
    let t = n.j.performance?.getEntriesByType?.("navigation")[0];
    if (!e || (t && t.responseStart > 0 && t.responseStart < performance.now())) return t;
  };
}
